// Centralized content file for flakesfriedchicken Box Restaurant
import logoImage from "./assets/image.png";

export const SITE_CONTENT = {
  global: {
    logoText: "Flakes Fried Chicken",
    logoImage: logoImage,
    topBar: {
      phone: "+91 91502 99336",
      email: "flakesfriedchicken17@gmail.com",
      socials: [
        { icon: "facebook", href: "https://facebook.com" },
        { icon: "twitter", href: "https://twitter.com" },
        { icon: "linkedin", href: "https://linkedin.com" },
        {
          icon: "youtube",
          href: "https://youtube.com/@flakesfriedchickenbox-s3w?si=-cSKTuS7a2PSNfiB",
        },
      ],
    },
    navLinks: [
      { label: "Menu", to: "/#menu" },
      { label: "Why Us", to: "/#why" },
      { label: "About", to: "/#about" },
      { label: "Blog", to: "/#blog" },
      { label: "Contact", to: "/#contact" },
    ],
    orderLinks: [
      {
        label: "Order on Swiggy 🛵",
        href: "https://www.swiggy.com/city/salem/flakesfriedchicken-main-rd-salem-bus-stand-rest883293",
        platform: "swiggy",
      },
      {
        label: "Order on Zomato 🍴",
        href: "https://www.zomato.com/salem/flakesfriedchicken-alagapuram-pudur",
        platform: "zomato",
      },
    ],
    orderLocations: {
      Salem: {
        zomato:
          "https://www.zomato.com/salem/flakesfriedchicken-alagapuram-pudur",
        swiggy:
          "https://www.swiggy.com/city/salem/flakesfriedchicken-main-rd-salem-bus-stand-rest883293",
      },
      Coimbatore: {
        zomato:
          "https://www.zomato.com/coimbatore/flakesfriedchicken-1-saibaba-colony",
        swiggy:
          "https://www.swiggy.com/city/coimbatore/flakesfriedchicken-venkitapuram-saibaba-colony-rest1151753",
      },
      Erode: {
        zomato:
          "https://www.zomato.com/erode/flakesfriedchicken-edayankattuvalasu/order",
        swiggy:
          "https://www.swiggy.com/city/erode/flakesfriedchicken-perundurai-rd-central-erode-rest875889",
      },
    },
    footer: {
      brandDesc:
        "Flakes Fried Chicken (FFC) is a 100% Halal certified premium quick-service restaurant brand in Tamil Nadu, serving crispy fried chicken, flakesfriedchickens, wraps, and sides.",
      socials: [
        { icon: "facebook", href: "https://facebook.com" },
        { icon: "twitter", href: "https://twitter.com" },
        { icon: "linkedin", href: "https://linkedin.com" },
        {
          icon: "youtube",
          href: "https://youtube.com/@flakesfriedchickenbox-s3w?si=-cSKTuS7a2PSNfiB",
        },
      ],
      cols: [
        {
          title: "Quick Links",
          links: [
            { label: "Our Menu", to: "#menu" },
            { label: "Order Online", to: "#order" },
            { label: "Why Us", to: "#why" },
            { label: "About", to: "#about" },
            { label: "Blog", to: "#blog" },
          ],
        },
        {
          title: "Order From",
          links: [
            {
              label: "Zomato",
              to: "https://www.zomato.com/salem/flakesfriedchicken-alagapuram-pudur/order",
            },
            { label: "Swiggy", to: "https://www.swiggy.com" },
            { label: "Call Directly", to: "tel:+919150299336" },
          ],
        },
        {
          title: "Our Locations",
          links: [
            { label: "Salem — Alagapuram Pudur", to: "/order?city=Salem" },
            { label: "Coimbatore", to: "/order?city=Coimbatore" },
            { label: "Erode", to: "/order?city=Erode" },
            {
              label: "flakesfriedchickenbox.in",
              to: "https://flakesfriedchickenbox.in",
            },
          ],
        },
      ],
      copy: "© 2025 flakesfriedchicken Box. All rights reserved.",
      parentBrand: {
        label: "A flakesfriedchickenbox Brand",
        href: "https://flakesfriedchickenbox.in",
      },
    },
  },
};
